module.exports = __webpack_public_path__ + "static/media/restaurant-placeholder.5b73f1f5.jpg";